<template>
    <section class="tables landing-page">
      <vue-snotify></vue-snotify>
      <div class="row mt-5">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
                <h4 class="card-title">Email history</h4>
            </div>
            <div class="card-body">
              <form action="" method="post">
                <div class="row">
                  <div class="col-md-4 col-sm-6">
                    <div role="group" class="form-group">
                      <div>
                        <input id="search" name="search" v-model="searchIndex.search"
                          @keyup="searchMarket" type="search" placeholder="Search"
                          class="form-control form-control-sm">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                  </div>
                </div>
              </form>
              <CircleLoader v-if="isLoading" />
              <vue-good-table
                mode="remote"
                :totalRows="tableConfig.totalRecords"
                :isLoading="isLoading"
                :paginationOptions="tableConfig.options"
                :sortOptions="{
                  enabled: true,
                  multipleColumns: true,
                  initialSortBy: searchIndex.sort[0]
                }"
                :rows="emailList"
                :columns="tableConfig.columns"
                @on-page-change="onPageChange"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
              >
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>

<script>
import Vue from "vue";
import API from "@/api";
import moment from 'moment'
import CircleLoader from '@/pages/loaders/CircleLoader.vue'; 
export default {
    data() {
        return {
            searchTime: '',
            searchIndex: {
                search: "",
                // GroupID: 1,
                sort: [
                    {
                        field: 'EmailSendTo', // example: 'name'
                        type: 'asc' // 'asc' or 'desc'
                    }
                ],
                page: 1, // what page I want to show
                perPage: 10
            },
            emailList: {
                name: "",
                email: "",
                status: ""
            },
             isLoading: false,
            tableConfig: {
                columns: [
                    {
                        label: 'Sent to',
                        field: 'EmailSendTo',
                        // type: 'text',
                        sortable: true,
                    },
                    {
                        label: 'Subject',
                        field: 'Emailsubject',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: 'Send Date',
                        field: 'Senddate',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: 'Topic',
                        field: 'Topic',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: 'PartID',
                        field: 'PartID',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: 'GroupID',
                        field: 'GroupID',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: 'EmailStatus',
                        field: "EmailStatus",
                        type: 'text',
                        sortable: true,
                    },
                    // {
                    //     label: 'Action',
                    //     field: "action",
                    //     sortable: false,
                    // },
                ],
                options: {
                    enabled: true,
                    dropdownAllowAll: false,
                    perPageDropdown: [10, 20, 50, 100, 200],
                },
                totalRecords: 0,
                isLoading: false
            }
        }
    },
    methods: {
        onSortChange(e){
            let typ = (this.searchIndex.sort[0].type=='asc'?'desc':'asc')
            this.searchIndex.sort[0].field = e[0].field;
            this.searchIndex.sort[0].type = typ;
            this.getMarketingEmailHistory();
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            console.log('yes');
            this.getMarketingEmailHistory();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.getMarketingEmailHistory();
        },
        updateParams(newProps) {
            this.searchIndex = Object.assign({}, this.searchIndex, newProps);
        },
        getMarketingEmailHistory() {
            this.isLoading = true
            API.getMarketingEmailHistory(this.searchIndex, this.emailListCB, this.errorCB);
        },
        groupBox() {
            this.getMarketingEmailHistory();
        },
        searchMarket() {
            clearTimeout(this.searchTime);
            this.searchTime = setTimeout(() => {
                this.getMarketingEmailHistory();
            }, 1000)
        }
        ,
        emailListCB(response) {
            this.tableConfig.totalRecords = response.data.total;
            let resData = response.data.data.map(data => {
                return {
                    EmailSendTo: data.EmailSendTo,
                    Emailsubject: data.Emailsubject,
                    Senddate: moment(data.Senddate).format('YYYY-MM-DD'),
                    EmailStatus: data.EmailStatus,
                    GroupID: data.GroupID,
                    Topic: data.Topic,
                    PartID: data.PartID,
                    
                }
                
            })
           
            console.log('resData :', resData);
            this.emailList = resData;
            // this.isLoading = false;
             this.isLoading = false
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
            this.isLoading = false;
        }
    },
    mounted() {
        this.isLoading = true;
        this.getMarketingEmailHistory();
    }
}
</script>